/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import { MOBILE_TYPES } from '../constants/recaptcha';

export const setRecaptchaData = (token, admin) => {
    const recaptcha = {};

    const mobileDeviceType = SecurityHelper.getMobileNativeRecaptchaType();

    recaptcha.profile = token;
    recaptcha.admin = admin;

    if (MOBILE_TYPES.includes(mobileDeviceType)) {
        recaptcha.admin = mobileDeviceType;
        recaptcha.profile = SecurityHelper.getMobileNativeRecaptchaToken();
    }

    return recaptcha;
};
